import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx={12}
      cy={11.9995}
      r={9.55385}
      stroke="#DF043A"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx={11.9999} cy={12} r={6} fill="#DF043A" />
  </svg>
);
export default SVGComponent;
